(function () {
  function getCartRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function getBundleCountFromItems(items) {
    const bundleIds = new Set();
    let regularCount = 0;

    (items || []).forEach((item) => {
      const properties = item.properties || {};
      const bundleId = properties._bundle_id;

      if (bundleId) {
        bundleIds.add(bundleId);
      } else {
        regularCount += item.quantity || 0;
      }
    });

    return bundleIds.size + regularCount;
  }

  function updateCartBubble(count) {
    document
      .querySelectorAll('[data-cart-count], .cart-bubble__text-count, .cart-bubble__text')
      .forEach((element) => {
        element.textContent = count;
        element.classList.remove('hidden');
        element.hidden = false;
      });
  }

  async function getCart() {
    const response = await fetch(getCartRoot() + 'cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Impossible de lire le panier');
    }

    return response.json();
  }

  async function removeBundleWithUpdate(bundleId, cart) {
    const updates = {};

    (cart.items || []).forEach((item) => {
      const properties = item.properties || {};

      if (properties._bundle_id === bundleId) {
        updates[item.key] = 0;
      }
    });

    if (!Object.keys(updates).length) {
      throw new Error('Aucune ligne trouvée pour ce pack');
    }

    const response = await fetch(getCartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    if (!response.ok) {
      throw new Error('Erreur cart/update.js');
    }

    return response.json();
  }

  async function removeBundleWithLines(bundleId, cart) {
    const lines = [];

    (cart.items || []).forEach((item, index) => {
      const properties = item.properties || {};

      if (properties._bundle_id === bundleId) {
        lines.push(index + 1);
      }
    });

    if (!lines.length) {
      throw new Error('Aucune ligne trouvée pour ce pack');
    }

    lines.sort((a, b) => b - a);

    let latestCart = cart;

    for (const line of lines) {
      const response = await fetch(getCartRoot() + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          line,
          quantity: 0
        })
      });

      if (!response.ok) {
        throw new Error('Erreur cart/change.js ligne ' + line);
      }

      latestCart = await response.json();
    }

    return latestCart;
  }

  function cartStillContainsBundle(cart, bundleId) {
    return (cart.items || []).some((item) => {
      const properties = item.properties || {};
      return properties._bundle_id === bundleId;
    });
  }

function getPackCartCountFromCart(cart) {
  const bundleIds = new Set();
  let regularCount = 0;

  (cart.items || []).forEach((item) => {
    const properties = item.properties || {};
    const bundleId = properties._bundle_id;

    if (bundleId) {
      bundleIds.add(bundleId);
    } else {
      regularCount += item.quantity || 0;
    }
  });

  return bundleIds.size + regularCount;
}

async function refreshCartBubble() {
  const response = await fetch(window.Shopify.routes.root + 'cart.js', {
    headers: {
      Accept: 'application/json'
    }
  });

  const cart = await response.json();
  const count = getPackCartCountFromCart(cart);

  document
    .querySelectorAll('.cart-bubble__text, [data-cart-count]')
    .forEach((element) => {
      element.textContent = count;
    });

  document
    .querySelectorAll('.cart-bubble')
    .forEach((bubble) => {
      if (count <= 0) {
        bubble.style.display = 'none';
        bubble.setAttribute('aria-hidden', 'true');
      } else {
        bubble.style.display = '';
        bubble.removeAttribute('aria-hidden');
      }
    });

  return count;
}

  async function removeBundle(button) {
    const bundleId = button.getAttribute('data-moq-bundle-id') || '';

    if (!bundleId) {
      button.textContent = 'Erreur pack';
      return;
    }

    button.disabled = true;
    button.textContent = 'Suppression...';

    try {
      const cart = await getCart();
      let updatedCart;

      try {
        updatedCart = await removeBundleWithUpdate(bundleId, cart);
      } catch (error) {
        updatedCart = await removeBundleWithLines(bundleId, cart);
      }

      if (cartStillContainsBundle(updatedCart, bundleId)) {
        const freshCart = await getCart();

        if (cartStillContainsBundle(freshCart, bundleId)) {
          throw new Error('Le pack est encore présent après suppression');
        }

        updatedCart = freshCart;
      }

      updateCartBubble(getBundleCountFromItems(updatedCart.items || []));
      const count = await refreshCartBubble();

if (count <= 0) {
  document.querySelectorAll('.cart-bubble').forEach((bubble) => {
    bubble.remove();
  });
}

window.location.reload();
    } catch (error) {
      console.error('Erreur suppression pack :', error);
      button.disabled = false;
      button.textContent = 'Réessayer';
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('[data-moq-remove-bundle]');

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      removeBundle(button);
    },
    true
  );
})();
